import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/site";

const LINKS = [
  ["servizi", "Menu servizi"],
  ["come-funziona", "Come funziona"],
  ["zone", "Zone"],
  ["contatti", "Contatti"],
];

export const Nav = ({ count }) => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };
  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="mx-auto mt-3 flex max-w-7xl items-center justify-between rounded-full border border-white/10 bg-[#070B14]/70 px-4 py-2.5 backdrop-blur-xl sm:mx-6 lg:mx-auto mx-3">
        <button data-testid="nav-brand-logo" onClick={() => go("top")} aria-label="Mister Multiservice">
          <Logo />
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="link-underline text-sm text-slate-300 transition-colors hover:text-white">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button data-testid="nav-cta-preventivo" onClick={() => go("contatti")} className="btn-cyan max-sm:!hidden">
            Preventivo{count > 0 && <span className="ml-1 rounded-full bg-black/80 px-2 text-xs text-[var(--cyan)]">{count}</span>}
            <ArrowUpRight className="h-4 w-4" />
          </button>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen((o) => !o)} className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-white md:hidden" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} className="mx-3 mt-2 rounded-3xl border border-white/10 bg-[#070B14]/95 p-6 backdrop-blur-xl md:hidden" data-testid="nav-mobile-menu">
            {LINKS.map(([id, label], i) => (
              <button key={id} data-testid={`nav-mobile-link-${id}`} onClick={() => go(id)} className="flex w-full items-baseline gap-4 border-b border-white/10 py-4 text-left font-display text-2xl font-semibold text-white">
                <span className="font-mono text-xs text-[var(--cyan)]">0{i + 1}</span>{label}
              </button>
            ))}
            <button data-testid="nav-mobile-cta" onClick={() => go("contatti")} className="btn-cyan mt-6 w-full justify-center">Richiedi preventivo</button>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
